import {Injectable} from "@angular/core";
import {HttpClientService} from "../httpClient/httpclient.service";
import {Permission} from "../../models/permission.model";
import {roleMS} from "../../models/roleMS.model";
import {Operation} from '../../models/operation.model';

@Injectable()
export class RolePermissionMSService {
  currentRolePermissions: Permission[];
  operations: Operation[];

  constructor(private h: HttpClientService,
  ) {
    this.currentRolePermissions = [];

  }

  getAll(role: roleMS) {
    console.log(role)
    return this.h.get(role.ms_base_url + "/permissions/api/" + role.id)
      .map(res => {
        this.currentRolePermissions = res;
      });
  }

  getAllByApplication(role: roleMS) {
    console.log(role)
    return this.h.get(role.ms_base_url + "/permissions/api/" + role.id + "/application/" + role.applicationId)
      .map(res => {
        this.currentRolePermissions = res;
      });
  }

  delete(role: roleMS, rolePermission: Permission) {
    return this.h.delete(role.ms_base_url + "/permissions/api/" + rolePermission.id) //+ rolePermission.id)
      .map(res => {

      });
  }

  getOperations(role: roleMS){
    return this.h.get(role.ms_base_url + "/permissions/operations")
      .map(res => {
        return this.operations = res;
      });
  }

  getOperationsByApplication(role: roleMS){
    return this.h.get(role.ms_base_url + "/permissions/operations/" + role.applicationId)
      .map(res => {
        return this.operations = res;
      });
  }





  post(role: roleMS, rolePermission: Permission) {
    return this.h.post(role.ms_base_url +  "/permissions/api", rolePermission)
      .map(res => {
        return res;
      });
  }
  put(role: roleMS, rolePermission: Permission) {
    return this.h.put(role.ms_base_url + "/permissions/api/" + rolePermission.id, rolePermission)
      .map(res => {

      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utils/rolePermissionMS.service.ts